import { BiCheck } from "react-icons/bi"
import { cn } from "../../utils/lib"

interface StepperProps {
    steps: string[]
    currentStep: number
}

const Stepper = ({ steps, currentStep }: StepperProps) => {
    return (
        <div className="w-full bg-white px-4">
            <div className="flex items-center justify-center">
                {steps.map((step, index) => {
                    const stepNumber = index
                    const isCompleted = stepNumber < currentStep
                    const isActive = stepNumber === currentStep
                    const isInactive = stepNumber > currentStep
                    return (
                        <div key={index} className="flex items-center">
                            <div className="flex flex-col items-center">
                                <div
                                    className={cn(
                                        "w-5 h-5 rounded-full flex items-center justify-center font-semibold text-xs transition-all",
                                        isCompleted && "bg-blue-600 text-white border border-blue-600",
                                        isActive && "bg-blue-200 text-blue-600",
                                        isInactive && "bg-gray-200 text-gray-400",
                                    )}
                                >
                                    {isCompleted ? <BiCheck className="w-4 h-4" /> : stepNumber + 1}
                                </div>
                                <span
                                    className={cn(
                                        "text-xs font-medium mt-1",
                                        isCompleted && "text-blue-600",
                                        isActive && "text-blue-600",
                                        isInactive && "text-gray-400",
                                    )}
                                >
                                    {step}
                                </span>
                            </div>
                            {index < steps.length - 1 && (
                                <div
                                    className={cn(
                                        "w-36 h-[2px] mx-8 rounded-lg  transition-all",
                                        stepNumber < currentStep ? "bg-blue-500" : "bg-gray-300",
                                    )}
                                />
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Stepper